// extracted by mini-css-extract-plugin
module.exports = {"NowShoppingBy":"NowShoppingBy_NowShoppingBy__n4zoA","Button":"NowShoppingBy_Button__n-r76","Header":"NowShoppingBy_Header__3wri3","Subheader":"NowShoppingBy_Subheader__3aSFT"};